import React from 'react';
import PropTypes from 'prop-types';
import MainAppBar from '../../components/MainAppBar';
import makeStyles from '@material-ui/core/styles/makeStyles';

const WithAppBar = props => {
  const useStyles = makeStyles(theme => ({
    root: {
      padding: props.noPadding ? 0 : theme.spacing(1)
    }
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MainAppBar
        color={props.color}
        history={props.history}
        icon={props.icon}
        onClick={props.onClick}
        progressive={props.progressive}
        title={props.title}
        titleAlign={props.titleAlign}
        type={props.type}
        variant={props.variant}
      />
      {props.children}
    </div>
  );
};

WithAppBar.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  history: PropTypes.object,
  icon: PropTypes.node,
  noPadding: PropTypes.bool,
  onClick: PropTypes.func,
  progressive: PropTypes.bool,
  title: PropTypes.string,
  titleAlign: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string
};

export default WithAppBar;
